/* ONAIR launch-clock, aligned to the exact 18-day promotion deadline.
 * Never start a per-visitor timer, use localStorage or claim a live deadline in draft mode.
 */
(function(){
 'use strict';
 var duration=18*24*60*60*1000;
 function init(root){
  if(root.dataset.oa16Bound==='true')return;
  root.dataset.oa16Bound='true';
  var days=root.querySelector('[data-oa16-days]');
  var hours=root.querySelector('[data-oa16-hours]');
  var minutes=root.querySelector('[data-oa16-minutes]');
  var seconds=root.querySelector('[data-oa16-seconds]');
  var status=root.querySelector('[data-oa16-status]');
  var note=root.querySelector('[data-oa16-description]');
  if(!days||!hours||!minutes||!seconds||!status||!note)return;
  var savedDeadline=-1;
  function pad(n){return String(n).padStart(2,'0');}
  function paint(remaining){
   var total=Math.max(0,Math.ceil(remaining/1000));
   days.textContent=pad(Math.floor(total/86400));
   hours.textContent=pad(Math.floor(total%86400/3600));
   minutes.textContent=pad(Math.floor(total%3600/60));
   seconds.textContent=pad(total%60);
   root.style.setProperty('--oa16-progress',String(Math.max(0,Math.min(100,remaining/duration*100)))+'%');
  }
  function render(){
   var config=window.ONAIR_LAUNCH;
   if(root.dataset.oa16Preview==='true'||window.Shopify?.designMode===true){
    root.hidden=false;root.dataset.oa16Mode='preview';
    status.textContent='DRAFT PREVIEW';
    note.textContent='Preview only. The live countdown appears once the launch checks are complete.';
    paint(duration);return;
   }
   var start=Number(config?.startsAtMs),end=Number(config?.endsAtMs);
   var active=!!(config&&config.production===true&&config.campaignApproved===true&&config.checkoutApproved===true&&config.windowValid===true&&config.marketEligible===true&&config.marketCurrency==='CAD'&&config.state?.()==='active'&&config.isEligible?.('essential',config.baseKey)===true&&config.priceMinor?.('essential',config.baseKey,456000,'CAD')===399000&&Number.isSafeInteger(start)&&Number.isSafeInteger(end)&&end-start===duration&&typeof config.now==='function'&&String(config.discountId||'').trim());
   if(!active){root.hidden=true;root.dataset.oa16Mode='inactive';return;}
   var remaining=end-config.now();
   if(!Number.isFinite(remaining)||remaining<=0||remaining>duration){root.hidden=true;root.dataset.oa16Mode='inactive';return;}
   if(savedDeadline!==end){
    savedDeadline=end;
    try{
     note.textContent='Ends '+new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',month:'short',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(new Date(end));
    }catch(error){note.textContent='Offer ending soon. See promotion terms.';}
   }
   root.hidden=false;root.dataset.oa16Mode='active';status.textContent='LIVE NOW';
   paint(remaining);
  }
  render();
  var interval=window.setInterval(render,1000);
  window.addEventListener('pageshow',render);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)render();});
  document.addEventListener('onair:launch-state-change',render);
  document.addEventListener('shopify:section:unload',function(event){if(event.target.contains(root))window.clearInterval(interval);});
 }
 function boot(){document.querySelectorAll('[data-oa16-countdown]').forEach(init);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',boot);
})();
